export const ARTICLE_ROUTE_TEMPLATE = "/resources/article/:slug";
